import type { AnnotationLabelT, AnswerT } from '../../../common/types/types';
import type { AnnotationDataT, AnnotationType } from '../../labelling/types/annotations.type';
import type { DynamicAnswerSpanT } from '../studio-store/types';
export enum BoundaryType {
  KeyFrame = 'keyFrame',
  SpanBoundary = 'spanBoundary',
}
export type FrameBoundary = {
  geometry: AnnotationDataT;
  index: number;
  type: BoundaryType;
};
export type AnnotationMeta = {
  label: AnnotationLabelT;
  annotationType: AnnotationType;
  answers?: AnswerT;
  dynamicAnswers?: DynamicAnswerSpanT[];
};
export type InterpolationTaskEnqueuePayload = {
  annotationId: string;
  startFrame: FrameBoundary;
  endFrame: FrameBoundary;
};
export type InterpolationTask = InterpolationTaskEnqueuePayload & {
  resolve: () => void;
  reject: (err: unknown) => void;
};